export enum FileGeodeticMapType {
  MAP_2D = 'MAP_2D',

  MODEL_3D = 'MODEL_3D',

  VR360 = 'VR360',

  TIMELAPSE = 'TIMELAPSE',
}
